import { fetcher } from '@commenda/utils';

import { GetJobResponse } from './types';

/**
 * GET /api/v1/new-sales-tax/jobs/:jobId?corporation_id=
 *
 * One-shot job fetch for manual "check status" buttons. The sibling `getJob` in
 * ./get.ts is an SWR hook, which polls on mount and cannot be driven by a
 * click; use this when the user decides when to look.
 *
 * Works for hidden jobs too — the upstream single-job route does not filter on
 * is_visible, unlike the jobs list — so it covers breakdown trigger jobs, which
 * are created invisible and therefore never appear in a listing.
 */
export async function getSalesTaxJob(
  jobId: string,
  corporationId: number
): Promise<{
  success: boolean;
  data?: GetJobResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/jobs/${jobId}?corporation_id=${corporationId}`,
      { method: 'GET' },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data?.message || 'Failed to fetch job',
      };
    }

    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
